/**
 * Header – mobilní menu
 *
 * Otevírání/zavírání hlavní navigace hamburger tlačítkem (.header-hmb-btn).
 * Řeší přístupnost: aria-expanded, aria-label, zavření klávesou Escape
 * a zavření po kliknutí na položku menu.
 */
function initMobileMenu() {
    const button = document.querySelector('.header-hmb-btn');
    const nav = document.getElementById('header-nav');
    if (!button || !nav) return;

    const OPEN_CLASS = 'is-open';

    const isOpen = () => button.getAttribute('aria-expanded') === 'true';

    const setOpen = (open) => {
        nav.classList.toggle(OPEN_CLASS, open);
        button.classList.toggle(OPEN_CLASS, open);
        document.body.classList.toggle('menu-open', open);
        button.setAttribute('aria-expanded', String(open));
        button.setAttribute('aria-label', open ? 'Zavřít menu' : 'Otevřít menu');
    };

    const close = () => setOpen(false);

    button.addEventListener('click', () => setOpen(!isOpen()));

    // Zavření klávesou Escape – fokus zpět na tlačítko
    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && isOpen()) {
            close();
            button.focus();
        }
    });

    // Zavření po kliknutí na odkaz v navigaci
    nav.addEventListener('click', (event) => {
        if (event.target.closest('a')) close();
    });
}

/**
 * Rollback – klik na .btn-rollback (kdekoli) vyjede stránku nahoru.
 * Delegace na document, aby fungovalo globálně i pro dynamicky vložené tlačítko.
 */
function initRollback() {
    document.addEventListener('click', (event) => {
        if (!event.target.closest('.btn-rollback')) return;
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
    });
}

/**
 * Auto-hide header – při scrollu dolů se header schová,
 * při scrollu nahoru (i lehkém) zase vyjede.
 */
function initHeaderScroll() {
    const header = document.getElementById('header');
    if (!header) return;

    const HIDDEN = 'header-hidden';
    const DELTA = 5;    // ignoruj mikropohyby / jitter
    const OFFSET = 120; // do této výšky (cca výška headeru) neschovávat
    let lastY = window.scrollY;
    let ticking = false;

    const update = () => {
        ticking = false;
        const y = Math.max(window.scrollY, 0);
        const diff = y - lastY;

        if (Math.abs(diff) <= DELTA) return; // moc malý pohyb – lastY nech být

        // při otevřeném mobilním menu header neschovávej
        if (!document.body.classList.contains('menu-open')) {
            if (diff > 0 && y > OFFSET) {
                header.classList.add(HIDDEN);    // scroll dolů → schovat
            } else if (diff < 0) {
                header.classList.remove(HIDDEN); // scroll nahoru → ukázat
            }
        }
        lastY = y;
    };

    window.addEventListener('scroll', () => {
        if (!ticking) {
            window.requestAnimationFrame(update);
            ticking = true;
        }
    }, { passive: true });
}

document.addEventListener('DOMContentLoaded', () => {
    initMobileMenu();
    initRollback();
    initHeaderScroll();
});
